import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
})
export default class Grid extends Vue {
    @Prop({ type: Boolean }) selectable!: any;
    @Prop({ type: Boolean }) editable!: any;
    @Prop({ type: Boolean }) completeable!: any;
    @Prop({ type: Array }) actions!: any;
    @Prop({ type: Number }) numColumns!: any;
    @Prop({ type: String }) gridTitle!: any;
    @Prop({ required: true }) value!: any;

    pagination = { sortBy: 'name', descending: false };

    get expandable() {
        return this.numColumns > 0;
    }

    get test() {
        return '<i aria-hidden="true" class="v-icon material-icons theme--light">refresh</i>';
    }

    changeSort(column: string) {
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending
        } else {
            this.pagination.sortBy = column
            this.pagination.descending = false
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/components/grid/grid.ts